// Fecha base usada por Excel para convertir números de serie a fechas (1899-12-30).
const EXCEL_EPOCH = new Date(Date.UTC(1899, 11, 30));

export function horaAMinutos(hora) {
  if (hora === null || hora === undefined || hora === '') return null;

  if (typeof hora === 'number') {
    // Excel guarda las horas como fracción de día (0.5 = 12:00).
    return Math.round(hora * 24 * 60);
  }

  const texto = String(hora).trim();
  const match = texto.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;

  const horas = parseInt(match[1], 10);
  const minutos = parseInt(match[2], 10);
  return horas * 60 + minutos;
}

export function minutosAHora(minutos) {
  const h = Math.floor(minutos / 60) % 24;
  const m = Math.round(minutos % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function parseFecha(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  if (valor instanceof Date) return valor;

  if (typeof valor === 'number') {
    return new Date(EXCEL_EPOCH.getTime() + valor * 24 * 60 * 60 * 1000);
  }

  const texto = String(valor).trim();

  const isoMatch = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return new Date(Date.UTC(+isoMatch[1], +isoMatch[2] - 1, +isoMatch[3]));
  }

  const dmyMatch = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (dmyMatch) {
    return new Date(Date.UTC(+dmyMatch[3], +dmyMatch[2] - 1, +dmyMatch[1]));
  }

  const fallback = new Date(texto);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

export function rangosSeTraslapan(inicioA, finA, inicioB, finB) {
  return inicioA < finB && inicioB < finA;
}

export function fechasSeTraslapan(inicioA, finA, inicioB, finB) {
  if (!inicioA || !finA || !inicioB || !finB) return true; // sin datos, se asume conservador
  return inicioA.getTime() <= finB.getTime() && inicioB.getTime() <= finA.getTime();
}
